"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcViewIsDirty = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const omit_1 = __importDefault(require("lodash/omit"));
function calcViewIsDirty(view) {
    if (!view.cleanLmss)
        return (view.isDirty = false);
    if (!(0, isEqual_1.default)(view.filters, view.cleanLmss.filters)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.groupBys.map(({ queryFieldKey }) => queryFieldKey), view.cleanLmss.groupBys.map(({ queryFieldKey }) => queryFieldKey))) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.highlightedGroups, view.cleanLmss.highlightedGroups)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.hideEmptyGroups, view.cleanLmss.hideEmptyGroups)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.sortByDesc, view.cleanLmss.sortByDesc)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.sortBy, view.cleanLmss.sortBy)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.pinField, view.cleanLmss.pinField)) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.fields.map(f => (0, omit_1.default)(f.label)), view.cleanLmss.fields.map(f => (0, omit_1.default)(f.label)))) {
        return (view.isDirty = true);
    }
    if (!(0, isEqual_1.default)(view.chartBox, view.cleanLmss.chartBox)) {
        return (view.isDirty = true);
    }
    return (view.isDirty = false);
}
exports.calcViewIsDirty = calcViewIsDirty;
exports.default = calcViewIsDirty;
